import { formatDuration } from '../duration.js';
import type { GameSettings as Settings } from '../api.js';

/**
 * How the host set the game up, under the key to the board.
 *
 * The labels are the setup screen's own, so a setting reads as the
 * question the host was asked. Every row says which way it went, off
 * included: a player checking for debris is not helped by a missing row.
 */
export function GameSettings({ settings }: { settings: Settings }) {
  const s = settings;
  const rows: [string, string][] = [
    ['Game mode', s.turnMode ? 'turn' : 'normal'],
    ['Maximum players', String(s.maxPlayers)],
    ['Life tokens', s.lifeTokens > 0 ? `${s.lifeTokens} each` : 'off: deaths are only counted'],
    ['Option cards', !s.optionsEnabled
      ? 'off'
      : s.optionCount === null
        ? `all ${s.optionCatalog}`
        : `${s.optionCount} of ${s.optionCatalog}`],
  ];
  if (s.optionsEnabled) {
    rows.push(['Options to start with', String(s.startingOptions)]);
  }
  rows.push(
    ['Debris', s.debrisEnabled ? 'on' : 'off'],
    ['Joining', s.lateJoin ? 'open after the start' : 'closed once started'],
    ['Programming timer', s.timerSeconds === null
      ? 'off'
      : s.timerMode === 'last'
        ? `${formatDuration(s.timerSeconds)} for the last player`
        : `${formatDuration(s.timerSeconds)} for the whole table`],
  );

  return (
    <section className="game-settings" aria-label="Game settings">
      <div className="hazard hazard-thin" role="presentation" />
      <table>
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label}>
              <th scope="row">{label}</th>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
